import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Button } from "@mui/material";
import AccountCircleOutlinedIcon from '@mui/icons-material/AccountCircleOutlined';
import { PAGE_LIST } from "../../pages";
import InnerLink from "../../components/InnerLink";
import { selectCurrentUser, selectUserToken } from "../../store/userSlice/userSelectors";
import { loginVerify } from "../../store/userSlice/userRequests";
import ProfileAvatar from "../ProfileAvatar";

const LoginLink = () => {
  const dispatch = useDispatch();
  const token = useSelector(selectUserToken);
  const user = useSelector(selectCurrentUser);

  useEffect(() => {
    if (token && !user?.company) {
      dispatch(loginVerify());
    }
  }, [token]);

  if (token && !user) {
    return null
  }

  if (!token) {
    return (
      <InnerLink href={PAGE_LIST.LOGIN}>
        <Button endIcon={<AccountCircleOutlinedIcon />} color='secondary'>
          Login/Register
        </Button>
      </InnerLink>
    );
  }

  return <ProfileAvatar />
}

export default LoginLink;